import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";

/**
 * Wraps marketing-page content that should fade/rise into view on scroll.
 * See .mk-reveal in index.css — respects prefers-reduced-motion.
 */
export default function Reveal({ as: Component = "div", delay, style, className, children, ...rest }) {
  const [ref, isVisible] = useScrollReveal();
  return (
    <Component
      ref={ref}
      className={`mk-reveal${isVisible ? " is-visible" : ""}${className ? ` ${className}` : ""}`}
      style={{ transitionDelay: delay ? `${delay}ms` : undefined, ...style }}
      {...rest}
    >
      {children}
    </Component>
  );
}
